const Functii = {
    changeArrayValues(val) {
        var number = val[0];
        var arrNumbers = val[1];

        var arr = arrNumbers;
        var index = arrNumbers.indexOf(number);
        if (index > -1) {
            arr = [
                ...arrNumbers.slice(0, index),
                ...arrNumbers.slice(index + 1)
            ];
        } else {
            if (arrNumbers.length < 15) {
                arr = arrNumbers.concat(number);
            }
        }
        return arr.sort((a, b) => a - b);
    },
    changeArrayValuesLotteries(val) {
        var number = val[0];
        var arrNumbers = val[1];

        var arr = arrNumbers;
        var index = arrNumbers.indexOf(number);
        if (index > -1) {
            arr = [
                ...arrNumbers.slice(0, index),
                ...arrNumbers.slice(index + 1)
            ];
        } else {
            arr = arrNumbers.concat(number);

        }
        return arr.sort((a, b) => a - b);
    },
    timeStartTrim(val) {
        var data = val.split(' ')[0];
        var ora = val.split(' ')[1];
        var dataArr = data.split('-')
        var oraArr = ora.split(':')
        var data2 = "" + dataArr[1] + "/" + dataArr[2] + "";
        var ora2 = "" + oraArr[0] + ":" + oraArr[1] + "";
        var display = "" + data2 + " " + ora2 + "";
        return display;
    },
    points(value) {
        if (!value) {
            return 0
        }
        value = parseFloat(value.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0], 10)
        var l10nEN = new Intl.NumberFormat("en-US")
        var nr = l10nEN.format(value)
        var checkIfNumber = parseInt(nr)
        if (isNaN(checkIfNumber) === false && typeof checkIfNumber === 'number') {
            return nr;      // 2 decimals
        } else {
            return value
        }
    },
}

export { Functii as default }